'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Remove;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Remove(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-remove ' + className, width: width, height: height, viewBox: '0 0 512 512' },
    _react2.default.createElement('path', { fill: color, d: 'M 400.00,64.00L 112.00,64.00 c-26.51,0.00-48.00,21.49-48.00,48.00l0.00,16.00 l 384.00,0.00 l0.00-16.00 C 448.00,85.49, 426.51,64.00, 400.00,64.00zM 316.16,32.00l 7.058,50.50L 188.782,82.50 l 7.057-50.50L 316.16,32.00 M 320.00,0.00L 192.00,0.00 c-13.20,0.00-25.495,10.696-27.321,23.769l-9.357,66.962 C 153.495,103.804, 162.80,114.50, 176.00,114.50l 160.00,0.00 c 13.20,0.00, 22.505-10.696, 20.679-23.769l-9.357-66.962C 345.495,10.696, 333.20,0.00, 320.00,0.00L 320.00,0.00z M 408.00,160.00L 104.00,160.00 c-17.60,0.00-30.696,14.341-29.103,31.869l 26.206,288.263C 102.696,497.659, 118.40,512.00, 136.00,512.00l 240.00,0.00 c 17.60,0.00, 33.304-14.341, 34.897-31.868l 26.205-288.263C 438.696,174.341, 425.60,160.00, 408.00,160.00z M 192.00,448.00l-48.00,0.00 l-16.00-224.00l 64.00,0.00 L 192.00,448.00 z M 288.00,448.00l-64.00,0.00 L 224.00,224.00 l 64.00,0.00 L 288.00,448.00 z M 368.00,448.00l-48.00,0.00 L 320.00,224.00 l 64.00,0.00 L 368.00,448.00z' })
  );
}

Remove.propTypes = _.IconPropTypes;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Remove/Remove.js
// module id = 143
// module chunks = 0 1 2 3 4 5 6 7 8 9